module.exports = __webpack_public_path__ + "static/media/as_share.a219f9db.png";